import * as z from "zod";

/**
 * Admin toggle for the "reviewed / done" per-team flag on the Recover
 * registrations dashboard. Sets or clears both
 * `telnyx_brand_registrations.reviewed_done_at` and
 * `reviewed_done_by_user_id` atomically.
 */
export const setRecoverRegistrationDone = {
  name: "setRecoverRegistrationDone" as const,
  input: z.object({ teamId: z.string(), done: z.boolean() }),
  output: z.object({
    ok: z.literal(true),
    reviewedDoneAt: z.date().nullable(),
    reviewedDoneByUserId: z.string().nullable(),
  }),
};
